/** Matches PermissionsSettings role select label formatting. */
const formatAtsRoleName = (name: string): string =>
  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

const GENERIC_ROLE_LABELS: Record<string, string> = {
  admin: 'Administrator',
  administrator: 'Administrator',
  standard: 'Standard',
  recruiter: 'Recruiter',
  default: 'Default',
};

/**
 * Fallback label for a remote user type when the backend could not resolve a
 * name from the organization's cached ATS role catalog. Numeric-only ids are
 * meaningless to a human, so they render as nothing.
 */
export const resolveRemoteUserTypeLabel = (
  userType: string | null | undefined,
): string | null => {
  if (!userType) return null;

  const generic = GENERIC_ROLE_LABELS[userType.toLowerCase()];
  if (generic) return generic;

  if (/^\d+$/.test(userType)) return null;

  return formatAtsRoleName(userType);
};
